import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { CreateMachinePartForm, CreateMachinePartPageHeader } from '@/components/pages/MachineParts/Create'
import { useWashingMachineParts } from '@/pages/WashingMachinePart/WashingMachinePart.hooks'

import { useMachineParts } from '../MachinePart.hooks'
import { useCreateMachinePart } from './Create.hooks'

const CreateMachinePart = () => {
  const { id } = useParams()
  const { createMachinePart, loading } = useCreateMachinePart()
  const { getAllWashingMachinePart, getWashingMachinePartsResponse } = useWashingMachineParts()
  const { getMachineParts, getMachinePartsResponse } = useMachineParts()

  useEffect(() => {
    getAllWashingMachinePart()
    getMachineParts(Number(id))
  }, [getAllWashingMachinePart, getMachineParts, id])

  return (
    <>
      <CreateMachinePartPageHeader />
      <CreateMachinePartForm
        {...{ loading, washingMachinePartData: getWashingMachinePartsResponse, machineParts: getMachinePartsResponse }}
        onSubmit={createMachinePart}
      />
    </>
  )
}

CreateMachinePart.displayName = 'CreateMachinePart'
export default CreateMachinePart
